import { useState } from "react";

export default function LegalPageContent({ data }) {
  const [activeButton, setActiveButton] = useState("en");

  return (
    <div className="container">
      <div className="pb-28">
        <div className="h-full flex items-center justify-center text-purple py-10">
          <div className="p-2">
            <button
              className={`text-[20px] p-4  ${
                activeButton === "en" ? "bg-pink" : "bg-[#DDDDDD]"
              }`}
              onClick={() => setActiveButton("en")}
            >
              London, UK
            </button>
          </div>
          <div className="p-2">
            <button
              className={`text-[20px] p-4  ${
                activeButton === "de" ? "bg-pink" : "bg-[#DDDDDD]"
              }`}
              onClick={() => setActiveButton("de")}
            >
              Berlin, DE
            </button>
          </div>
        </div>
        {(activeButton === "en" ? data?.content : data?.content_de)?.map(
          (item) => (
            <div key={item.id}>
              <div className=" border-t border-[#26262680] opacity-50 my-4"></div>
              <div className="flex flex-col md:flex-row m-0">
                <div className="md:w-2/6 p-5">
                  <h5 className="text-[30px] text-purple">{item.title}</h5>
                </div>
                <div className="md:w-4/6 p-5">
                  <div
                    id="dynamicPrivacyContent"
                    className="text-[20px]"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </div>
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  );
}
